import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { IBankResponse, ICreateReferredUserRequest } from "@finbackoffice/clientbff-client";
import { InferType } from "yup";
import { BonusVertical } from "@finbackoffice/enums";
import { ClientBFFContext } from "../../providers";
import { createSubagentValidationSchema } from "../../validation-schemas";
import { AgentConfigContext } from "./agent-config.provider";

export type ICreateSubuserValidationSchema = InferType<typeof createSubagentValidationSchema>;

export interface ICreateSubuserForm extends ICreateSubuserValidationSchema {
    username: string;
    phone: string;
    email: string;
    first_name: string;
    last_name: string;
    password: string;
    agent_code: string;
    sport_cashback: number;
    live_casino_cashback: number;
    slots_cashback: number;
    bank_name: string;
    account_number: string;
    account_holder: string;
}
export interface ICreateSubuserRequest extends ICreateReferredUserRequest {
    sport_cashback: number;
    live_casino_cashback: number;
    slots_cashback: number;
}

export const useCreateSubuser = () => {
    const client = useContext(ClientBFFContext);
    const { agentConfig, updateAgentConfig } = useContext(AgentConfigContext);
    const [banks, setBanks] = useState<IBankResponse[]>([]);

    const createSubuser = useCallback(
        async (data: ICreateSubuserRequest) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { sport_cashback, live_casino_cashback, slots_cashback, ...rest } = data;
            const response = await client.createReferredUser(rest);

            if (agentConfig) {
                await updateAgentConfig({
                    ...agentConfig,
                    [BonusVertical.Sport]: {
                        ...agentConfig.Sport,
                        users: [
                            ...agentConfig.Sport.users,
                            { user_id: response.id, rate: sport_cashback },
                        ],
                    },
                    // @TODO: check live casino and slots cashback backend api
                    // [BonusVertical.Casino]: {
                    //     ...agentConfig.Casino,
                    //     users: [
                    //         ...agentConfig.Casino.users,
                    //         { user_id: response.id, rate: slots_cashback },
                    //     ],
                    // },
                    // [BonusVertical.LiveCasino]: {
                    //     ...agentConfig.LiveCasino,
                    //     users: [
                    //         ...agentConfig.LiveCasino.users,
                    //         { user_id: response.id, rate: live_casino_cashback },
                    //     ],
                    // },
                });
            }
        },
        [client, agentConfig, updateAgentConfig],
    );

    useEffect(() => {
        async function load() {
            const response = await client.banks();
            setBanks(response.items);
        }

        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return useMemo(
        () => ({
            banks,
            createSubuser,
        }),
        [banks, createSubuser],
    );
};
